import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CommonService } from '../Common.service';
import { RestApiService } from '../rest-api.service';

@Injectable({
  providedIn: 'root'
})
export class DocumentRevisionLinkService {

private getGroup ="DEDED/GetDEDAgainstDE";
private InsertDocRevision ="DocumentRevisionLink/PostDocumentRevision";
private getDocRevision = "DocumentRevisionLink/GetDocumentRevision";

constructor(private commonService: CommonService,private restApiService: RestApiService) { }
  
getGroupData():Observable<any>{
  let obj:any ={
    "DEDescription": "Workflow Status",
    "dependentDEDId": null,
    "dependentDEId": null,
    "groupId": null,
    "moduleId": null,
    "projectId": this.commonService.getProjectId()
  }
  return this.restApiService.new_POST(this.getGroup,obj);
}

insertDocumentRevision(obj:any):Observable<any>{ 
  return this.restApiService.new_POST(this.InsertDocRevision,obj);
}

getDocumentRevision(obj:any):Observable<any>{  
  return this.restApiService.new_POST(this.getDocRevision,obj);
}
}
